import { APIClient } from '@tokyojob/frontend-core'

export class GatewayBase {
  apiClient: APIClient

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
  }
}
